import { render, staticRenderFns } from "./display-field-payment-request.vue?vue&type=template&id=445a73e9&scoped=true&"
import script from "./display-field-payment-request.vue?vue&type=script&lang=ts&"
export * from "./display-field-payment-request.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a73e9",
  null
  
)

export default component.exports